
import { useState, useEffect } from 'react';

const DISCLAIMER_DISMISSED_KEY = 'disclaimer-dismissed';

export default function useDisclaimerVisibility() {
  const [isDismissed, setIsDismissed] = useState(() => {
    const dismissed = localStorage.getItem(DISCLAIMER_DISMISSED_KEY);
    return dismissed === 'true';
  });

  const dismissDisclaimer = () => {
    setIsDismissed(true);
    localStorage.setItem(DISCLAIMER_DISMISSED_KEY, 'true');
  };

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === DISCLAIMER_DISMISSED_KEY) {
        setIsDismissed(e.newValue === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    isDismissed,
    dismissDisclaimer,
  };
}
